/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
import React, { useState, useEffect, useContext } from 'react';
import { FormBuilder } from '../FormBuilder/formbuilder.component';
import renderService from '../../services/Render/render.service';
import { PriorAuthorizationDomain, UploadedFilesInfo } from '../../interfaces/PriorAuthorizationDomain';
import { IFormSchemaWithData } from '../../interfaces/IFormSchemaWithData';
import { PriorAuthorizationDomainContext } from '../../context/ctxPriorAuthorizationDomain';
import './priorauthrequestform.component.css';
import { appInsights } from '../../AppInsights';

interface IRequestFormProps {
  priorAuthDomainObj: PriorAuthorizationDomain,
  uploadedDocs?: UploadedFilesInfo[]
}

export const PriorAuthRequestForm = ({ priorAuthDomainObj, uploadedDocs }: IRequestFormProps) => {
  const [formDataArray, setFormDataArray] = useState<IFormSchemaWithData[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const { priorAuthorizationDomain, updatePriorAuthorizationDomain } = useContext(PriorAuthorizationDomainContext);

  useEffect(() => {
    const fetchJsonDataForUi = async () => {
      try {
        setIsLoading(true);
        if (priorAuthDomainObj.priorAuthorizationDomainHeader && priorAuthDomainObj.priorAuthorizationDomianDetails) {
          const fetchedDatapromises = priorAuthDomainObj.priorAuthorizationDomianDetails.map(async (priorAuthDomainObjDetails) => {
            const formSchema = await renderService.loadFormRenderJSON(
              priorAuthDomainObj.priorAuthorizationDomainHeader?.healthPlan?.toLowerCase(),
              priorAuthDomainObjDetails.typeOfServiceDescription?.toLowerCase(),
              priorAuthDomainObjDetails.authorizationType?.toLowerCase(),
            );
            return {
              priorAuthDomainObjDetails,
              formSchema,
            };
          });
          const fetchedData = await Promise.all(fetchedDatapromises);
          setFormDataArray(fetchedData);
          updatePriorAuthorizationDomain(priorAuthDomainObj);
        }
      } catch (error) {
        console.error('Error Fecthing Data', error);
        appInsights.trackTrace({ message: 'Error Fecthing Data' });
      } finally {
        setIsLoading(false);
      }
    };
    fetchJsonDataForUi();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="PriorAuthRequestForm">...Data Loading.....</div>
      ) : (
        <div className="PriorAuthRequestForm">
          <div>
            <FormBuilder formSchemaWithData={formDataArray} uploadedDocs={uploadedDocs} />
          </div>
        </div>
      )}
    </>
  );
};

export default PriorAuthRequestForm;
